module.exports = __webpack_public_path__ + "img/picture_01@2x.a5294e77.png";